import { adminHttp as http } from "@shared/lib/http";

function toQuery(params?: Record<string, unknown>) {
  if (!params) return "";
  const usp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === "") continue;
    usp.set(k, String(v));
  }
  const s = usp.toString();
  return s ? `?${s}` : "";
}

export const api = {
  async get<T = unknown>(
    path: string,
    opts?: { params?: Record<string, unknown> },
  ): Promise<{ data: T }> {
    const p = `${path}${toQuery(opts?.params)}`;
    const data = await http.get<T>(p);
    return { data };
  },
  async post<T = unknown>(path: string, body?: unknown): Promise<{ data: T }> {
    const data = await http.post<T>(path, body as any);
    return { data };
  },
  async put<T = unknown>(path: string, body?: unknown): Promise<{ data: T }> {
    // Map PUT to PATCH in our lightweight client
    const data = await http.patch<T>(path, body as any);
    return { data };
  },
  async delete<T = unknown>(path: string): Promise<{ data: T }> {
    // Simulate delete via POST for the stub client
    const data = await http.post<T>(path, { _method: "DELETE" });
    return { data };
  },
};
